import styled from 'styled-components';
import type { InsightPullQuoteBlock } from '../../types';

const Wrap = styled.blockquote<{ $accent: string; $ink: string }>`
  max-width: 46rem;
  margin: 0 auto;
  padding: 0 0 0 1.4rem;
  border-left: 3px solid ${({ $accent }) => $accent};
  color: ${({ $ink }) => $ink};
`;

const Quote = styled.p`
  margin: 0;
  font-family: var(--font-serif);
  font-size: clamp(1.45rem, 2.8vw, 2.2rem);
  line-height: 1.32;
  letter-spacing: -0.025em;
`;

const Attribution = styled.footer`
  margin-top: 0.9rem;
  font-size: 0.83rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(20, 34, 53, 0.62);
  font-weight: 800;
`;

type PullQuoteBlockProps = {
  block: InsightPullQuoteBlock;
  accent: string;
  ink: string;
};

export default function PullQuoteBlock({ block, accent, ink }: PullQuoteBlockProps) {
  return (
    <Wrap $accent={accent} $ink={ink}>
      <Quote>{block.quote}</Quote>
      {block.attribution ? <Attribution>{block.attribution}</Attribution> : null}
    </Wrap>
  );
}
